import React from 'react';

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends React.Component<
  React.PropsWithChildren,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Unhandled app error:', error);
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#070B14',
            color: '#E5E7EB',
            padding: '24px',
            textAlign: 'center',
            fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          }}
        >
          <div>
            <h1 style={{ margin: '0 0 12px 0', fontSize: '22px', fontWeight: 700 }}>
              The editor hit an unexpected error.
            </h1>
            <p style={{ margin: '0 0 20px 0', opacity: 0.8 }}>
              Reload to recover. Your latest changes should re-sync when the connection stabilizes.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                background: '#2563EB',
                color: '#fff',
                border: 0,
                borderRadius: '8px',
                padding: '10px 14px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Reload App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
